
import ResultsNetworkBannerOutOfServiceArea from '../components/results/networkBanner/ResultsNetworkBannerOutOfServiceArea.vue' 
import ResultsNetworkBannerOutOfNetwork from '../components/results/networkBanner/ResultsNetworkBannerOutOfNetwork.vue' 
import ResultsNetworkBannerByContractSoucerForDentistOrDental from '../components/results/networkBanner/ResultsNetworkBannerByContractSoucerForDentistOrDental.vue'
import ResultsNetworkBannerByContractSoucerForDoctorOrMedical from '../components/results/networkBanner/ResultsNetworkBannerByContractSoucerForDoctorOrMedical.vue'
import ResultsNetworkBannerInNetwork from '../components/results/networkBanner/ResultsNetworkBannerInNetwork.vue'
import ResultsNetworkBannerInNetworkTravelNetwork from '../components/results/networkBanner/ResultsNetworkBannerInNetworkTravelNetwork.vue'
import ResultsNetworkBannerUnauthenticated from '../components/results/networkBanner/ResultsNetworkBannerUnauthenticated.vue'
import ResultsNetworkBannerDentalAuthNoBenefits  from '../components/results/networkBanner/ResultsNetworkBannerDentalAuthNoBenefits.vue'
import ResultsNetworkBannerDentalAuthBenefits  from '../components/results/networkBanner/ResultsNetworkBannerDentalAuthBenefits.vue'
import ResultsNetworkBannerDentalNonAuth from '../components/results/networkBanner/ResultsNetworkBannerDentalNonAuth.vue'
import ResultsNetworkBannerUrgentCareBenefit from '../components/results/networkBanner/ResultsNetworkBannerUrgentCareBenefit.vue'
import ResultsNetworkBannerEyeCare from '../components/results/networkBanner/ResultsNetworkBannerEyeCare.vue'

export default (model, result) => {
    const { profile, plan, context, benefitCategories, env } = model

    const isAuthenticated = () => {
        return profile.value.isAuthenticated
    }

    const isPCCPlan = () =>{
        return plan.value.primaryCareClinic && plan.value.primaryCareClinic.careNetwork ? true : false
    }



    /**
     * Return true if the care network selected by the user ( represented in the context.careNetworkId ) matches
     * the careNetwork of the primary care clinic ( PCC ) of the user's plan.
     */
    const selectedCareNetworkMatchesPCCCareNetwork = () => {
        return context.value.careNetworkId === plan.value?.primaryCareClinic?.careNetwork?.id 
    }

    /**
     * Evaluate the state of the application to determine whether to display the PCCOUtOfNetworkBanner.
     * Associated with the following component:  ResultsNetworkBannerOutOfNetwork
     */
    const showResultsNetworkBannerOutOfNetwork = () => {
        //If this IS a primaryCareClinic ( PCC ) plan and the careNetworkId selected by the user is NOT the careNetworkId of the 
        //primaryCareClinic on the user's plan then return true, we should show the component.
        return isAuthenticated() && isPCCPlan() && !selectedCareNetworkMatchesPCCCareNetwork()
    }

     /**
     * Evaluate the state of the application to determine whether to display the OutofServiceArea.
     */

    const showResultsNetworkBannerOutOfServiceArea = () => {
        //If this result contains outOfServiceArea = true then  we should show the component.
        return isAuthenticated() && result?.outOfServiceArea
    }

    /**
     * Evaluate the state of the application to determine whether to display the PCC In Network banner.
     */
    const showResultsNetworkBannerInNetwork = () => {

        //If we are not authenticated we should not show the banner.
        if ( !isAuthenticated() ) return false

        //If this is a PCC plan, we need to see if the care netwok selected by the
        //user in their filters matches the careNetwork of their primary care clinic.
        //If not, then it is not in-network and this banner should not be displayed.
        if ( isPCCPlan() ) {
            return selectedCareNetworkMatchesPCCCareNetwork()
        }

        return true
    }

    /**
     * Evaluate the state of the application to determine whether to display the TravelNetwork banne
     */
    const showResultsNetworkBannerInNetworkTravelNetwork = () => {
        return isAuthenticated() && plan.value.isTravelNetwork 
    }

    const showResultsNetworkBannerUnauthenticated = () => {
        return !isAuthenticated()
    }

    const showResultsNetworkBannerDentalAuthNoBenefits = () => {

        //This is feature flagged.  If not in dev automatically return false
        if ( !(env.value == 'dev' || env.value == 'local')) return false
        if ( !isAuthenticated() ) return false

        //If there are benefitCategoires - i.e benefit search returned benefits, then return false.  This is not the right
        //component.
        if ( benefitCategories.value ) return false

        return (context.value.type == 'dentist' || context.value.type == 'dental') && plan.value.practiceType == 'Medical'
    }

    const showResultsNetworkBannerDentalAuthBenefits = () => {
        // *TEMPORARY* This banner is not currently working AND it stops progress in dev/local
        return false
        //This is feature flagged.  If not in dev automatically return false
        if ( !(env.value == 'dev' || env.value == 'local')) return false
        if ( !isAuthenticated() ) return false

        //If there are NO benefitCategoires - i.e benefit search returned benefits, then return false.  This is not the right
        //component.
        if ( !benefitCategories.value ) return false        

        return (context.value.type == 'dentist' || context.value.type == 'dental') && plan.value.practiceType == 'Medical'
    }    

    const showResultsNetworkBannerDentalNonAuth = () => {
        //This is feature flagged.  If not in dev automatically return false
        if ( env.value != 'dev' ) return false
        if ( isAuthenticated() ) return false
        return (context.value.type == 'dentist' || context.value.type == 'dental') && plan.value.practiceType == 'Medical'
    }

    const showResultsNetworkBannerUrgentCareBenefit = () => {
        return isAuthenticated() && benefitCategories?.value?.length > 0 && ( context.value.type == 'urgent' )
    }

    const showResultsNetworkBannerEyeCare = () => {
        if ( !isAuthenticated() ) return false
        if ( !( context.value.type == 'doctor' || context.value.type == 'medical') ) return false

        const inclusionList = [
            'Optometry (Routine care)',
            'Optometry (Non-routine care)',
            'Pediatric Optometry',
            'Ophthalmology',
            'Ophthalmology (Non-routine care)',
            'Pediatric Ophthalmology'
        ]

        //console.log(`List includes ${context.term")
        return ( context.value.term && inclusionList.includes(context.value.term.trim()))
    }

    // when contractsouce is either "CIGNA", "Midlands Choice for medial or doctor"
    const showResultsNetworkBannerByContractSourceForDoctorOrMedical = () => {
        if ( !isAuthenticated() ) return false
        return (context.value.type == 'doctor' || context.value.type == 'medical') && result?.contractSource && (result?.contractSource == 'CIGNA' || result?.contractSource == 'Midlands Choice')
    }

    // when contractsouce is either "CIGNA", "DENTAL CIGNA" , "DENTEMAX" for dentist or dental"
    const showResultsNetworkBannerByContractSourceForDentistOrDental = () => {
        if ( !isAuthenticated() ) return false
        return (context.value.type == 'dentist' || context.value.type == 'dental') && result?.contractSource && (result?.contractSource == 'DENTAL CIGNA' || result?.contractSource == 'DENTEMAX' || result?.contractSource == 'CIGNA')
    }



    /**
     * This function evaluates the model to determine which network banner should be displayed in the details card.  It 
     * does this by evaluating a series of rulesets.  The first ruleset that matches will be returned.  It is possible that
     * rulesets could overlap.  For example, a general banner might match the conditions of a more specific banner like the
     * "Travel-Network in network banner".  Therefore, prioritization is determined by the order in which the rulesets are
     * executed.  The higher priority rulesets should be at the top of the execution order.  So, for example, banners that
     * handle the travel network or PCC plans should be placed at the top so that their more specific rulesets will get 
     * exeucuted before general rulesets.  If we don't do this, all te specific cases would probably end up in the general
     * banners - like the general in-network banner.  If there are conflicts - for example if a Travel Network plan was also 
     * a PCC plan, the BA is going to have to decide which banner takes priority since the rulesets of a couple of different
     * banners would be fulfilled.  The higher priority scnenario should execute first.
     */
    const getNetworkBannerComponent = () => {
        if ( showResultsNetworkBannerOutOfServiceArea() ) return ResultsNetworkBannerOutOfServiceArea
        if ( showResultsNetworkBannerInNetworkTravelNetwork() ) return ResultsNetworkBannerInNetworkTravelNetwork
        if ( showResultsNetworkBannerOutOfNetwork() ) return ResultsNetworkBannerOutOfNetwork
        if ( showResultsNetworkBannerDentalAuthBenefits() ) return ResultsNetworkBannerDentalAuthBenefits
        if ( showResultsNetworkBannerDentalAuthNoBenefits() ) return ResultsNetworkBannerDentalAuthNoBenefits
        if ( showResultsNetworkBannerDentalNonAuth() ) return ResultsNetworkBannerDentalNonAuth
        if ( showResultsNetworkBannerUrgentCareBenefit() ) return ResultsNetworkBannerUrgentCareBenefit
        if ( showResultsNetworkBannerEyeCare() ) return ResultsNetworkBannerEyeCare
        if ( showResultsNetworkBannerByContractSourceForDoctorOrMedical() ) return ResultsNetworkBannerByContractSoucerForDoctorOrMedical
        if ( showResultsNetworkBannerByContractSourceForDentistOrDental() ) return ResultsNetworkBannerByContractSoucerForDentistOrDental
        if ( showResultsNetworkBannerInNetwork() ) return ResultsNetworkBannerInNetwork
        if ( showResultsNetworkBannerUnauthenticated() ) return ResultsNetworkBannerUnauthenticated

        return null
    }

    return {
        getNetworkBannerComponent, 
        showResultsNetworkBannerOutOfServiceArea,
        showResultsNetworkBannerInNetworkTravelNetwork, 
        showResultsNetworkBannerOutOfNetwork, 
        showResultsNetworkBannerEyeCare,
        showResultsNetworkBannerByContractSourceForDoctorOrMedical,
        showResultsNetworkBannerByContractSourceForDentistOrDental,
        showResultsNetworkBannerInNetwork,
        showResultsNetworkBannerDentalAuthBenefits,
        showResultsNetworkBannerDentalAuthNoBenefits,        
        showResultsNetworkBannerDentalNonAuth,
        showResultsNetworkBannerUnauthenticated,
        showResultsNetworkBannerUrgentCareBenefit
    }

}